<template>
    <v-form-tile>
        <h2 slot="title">{{title}}</h2>
        <div slot="description">
            <slot/>
        </div>
        <div slot="content" class="tile">
            <div class="tile-content cursor-pointer" @click="toggleSection">
                <div class="grid-content grid-unstackable">
                    <div class="grid-item"><h3>{{title}}</h3></div>
                    <div class="grid-item no-flex text-right">
                        <v-toggle
                            @input="toggleSection"
                            :selected="isEnabled"
                            :value="true"/>
                    </div>
                </div>
            </div>
            <div v-if="isEnabled" class="tile-content">
                <div class="grid-content">
                    <div class="grid-item grid-item-half grid-item-break-half" v-if="plans">
                        <v-select
                            :options="plans"
                            preselect-first
                            label="Plan"
                            :value="field.planId"
                            @input="updatePlanId"
                            help-text="Select the plan to offer to the customer."/>
                    </div>
                    <div class="grid-item grid-item-half grid-item-break-half">
                        <r-checkbox
                            :label="toggleTitle"
                            :caption="toggleCaption"
                            :value="true"
                            @input="toggleOptionState"
                            :selected="toggleState"/>
                    </div>
                </div>
            </div>
        </div>
    </v-form-tile>
</template>

<script>
    import {
        vFormTile, vSelect, vToggle,
    } from '@/components/form';

    export default {
        name: 'plan-offer',
        components: {
            vFormTile, vSelect, vToggle,
        },
        props: {
            title: String,
            description: String,
            plans: Array,
            field: Object,
            toggleField: String,
            toggleTitle: String,
            toggleCaption: String,
        },
        computed: {
            isEnabled() {
                return this.field !== null;
            },
            toggleState() {
                if (this.isEnabled) {
                    return this.field[this.toggleField];
                }
                return false;
            },
        },
        methods: {
            toggleSection() {
                this.$emit('toggle', this.isEnabled ? null : true);
            },
            toggleOptionState(value) {
                this.$emit('input', this.field.cloneSelf({[this.toggleField]: value}));
            },
            updatePlanId(planId) {
                this.$emit('input', this.field.cloneSelf({planId}));
            },
        },
    };
</script>

<style scoped>

</style>
